import {
  BooleanFilter,
  BooleanFilterTypes,
  CurrencyFilterTypes,
  DateRangeFilter,
  FilterOperatorTypes,
  MultiSelectIntFilter,
  TxnCurrencyFilter,
  TxnSearchFilter,
  TxnSearchFilterKeys,
} from '../../graphql/types';

export const buildBooleanFilterObject = (key: string, value: boolean): BooleanFilter => ({
  key: key as BooleanFilterTypes,
  value,
});

export const buildDateFilterObject = (dateString: string): DateRangeFilter => ({
  fromDate: dateString,
  toDate: dateString,
});

export const buildMethodIdFilterObject = (methodId: string): TxnSearchFilter => ({
  key: TxnSearchFilterKeys.methodId,
  value: methodId,
  operator: FilterOperatorTypes.Is,
});

export const buildTxnHashFilterObject = (hash: string): TxnSearchFilter => ({
  key: TxnSearchFilterKeys.txnHash,
  value: hash,
  operator: FilterOperatorTypes.Is,
});

export const buildFromAddressFilterObject = (fromAddress: string): TxnSearchFilter => ({
  key: TxnSearchFilterKeys.fromAddress,
  value: fromAddress,
  operator: FilterOperatorTypes.Is,
});

export const buildToAddressFilterObject = (toAddress: string): TxnSearchFilter => ({
  key: TxnSearchFilterKeys.toAddress,
  value: toAddress,
  operator: FilterOperatorTypes.Is,
});

export const buildCredentialIdFilterObject = (credentialId: number): MultiSelectIntFilter => ({
  values: [credentialId],
  operator: FilterOperatorTypes.Is,
});

export const buildCredentialIdsFilterObject = (credentialIds: number[]): MultiSelectIntFilter => ({
  values: credentialIds,
  operator: FilterOperatorTypes.Is,
});

export const buildReconIdentifierFilterObject = (reconIdentifier: string): TxnSearchFilter => ({
  key: TxnSearchFilterKeys.reconIdentifier,
  value: reconIdentifier,
  operator: FilterOperatorTypes.Is,
});

export const buildTxnTopicFingerprintFilterObject = (txnTopicFingerprint: string): TxnSearchFilter => ({
  key: TxnSearchFilterKeys.txnTopicFingerprint,
  value: txnTopicFingerprint,
  operator: FilterOperatorTypes.Is,
});

export const buildTransferTopicFingerprintFilterObject = (
  transferTopicFingerprint: string,
): TxnSearchFilter => ({
  key: TxnSearchFilterKeys.transferTopicFingerprint,
  value: transferTopicFingerprint,
  operator: FilterOperatorTypes.Is,
});

export const buildCurrencyFilterObject = (
  currency: string,
  side?: CurrencyFilterTypes,
): TxnCurrencyFilter => ({
  side: side || CurrencyFilterTypes.Currency,
  symbols: [currency],
  operator: FilterOperatorTypes.Is,
});
